<template>
    <div class="test-result-25jan">
        <div class="test-name-search-25jan">
            <div class="search-test-name">
                <v-text-field
                  v-model="testName"
                  @keydown="onSearch()"
                  solo
                  label="Test Name"
                  dense
                  outlined
                  hide-details
                  append-icon="search"
                  autocomplete="off"
                ></v-text-field>
            </div>
        </div>
        <v-card class="mx-auto normal-card">
        <div class="data-table-section assignment-table">
            <v-data-table
            :headers="headers"
            fixed-header
            :items="items"
            hide-default-header
            hide-default-footer
            class="elevation-2 cust-table"
            >
            <template v-slot:header="{ props: { headers } }">
                <TableHeader
                :headers="headers"
                :onSortChange="onSortChange"
                :onHeaderAction="onHeaderAction"
                :orderBy="orderBy"
                />
            </template>
            <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="item in items" :key="item.name">
                      <td> {{ item.test_name }} </td>
                      <td class="duration-display assignment-120"> {{ startDate(item.date_answered) }} </td>
                      <td class="duration-display">{{ filterdOptions(item) }}</td>
                      <td class="text-center"> {{ item.target_name }} </td>
                      <td class="text-center"> {{ item.subjects }} </td>
                      <td class="download-icon">
                        <v-img class="loader-img" src="../../../../assets/img/loading.gif" v-if="item.status == downloadStatus.IN_PROGRESS"
                         ></v-img>
                    <!-- <v-btn
                      v-else-if="item.status===downloadStatus.COMPLETED"
                      class="download-btn-cp3"
                      color="transparent"
                      depressed
                      @click="downloadTestURL(item)"
                    >
                      <v-img
                      src="../../../../assets/img/svg/download2.svg"
                      ></v-img>
                    </v-btn> -->
                    <v-btn
                      v-else
                      class="download-btn-cp3"
                      color="transparent"
                      depressed
                      @click="downloadTest(item)"
                      
                    >
                      <v-img
                        width="23px"
                        src="../../../../assets/img/download.svg"
                        ></v-img>
                    </v-btn>
                       
                      </td>
                    </tr>
                </tbody>
            </template>
            </v-data-table>
        </div>
        </v-card>
        <div class="footer-btn">
        <div class="pull-left"></div>
        <div class="pull-right">
            <Pagination
            :currentPage="currentPage"
            :totalPage="totalPages"
            :onPageChange="onPageChange"
            />
        </div>
        </div>
        <AlertBox
        :width="modalwidth"
        :onClose="onClose"
        :component="cComponent"
        :status="status"
        :data="alertBoxData"
        />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";


export default {
  name: "TestReports",
  async mounted() {
    (this.headers = [
      {
        text: "Test Name",
        value: "test_name",
      },
      {
        text: "Date",
        value: "test_date",
        class: "text-center"
      },
      {
        text: "Test Type",
        value: "test_type",
        class: "text-center",
        allText: "All Test Types",
        hideSort: true,
      },
      {
        text: "Target Exam",
        value: "target_exam",
        class: "text-center"
      },
      {
        text: "Subjects",
        value: "subjects",
        class: "text-center",
        hideSort: true,
      },
      { text: "",
        value: "",
        type: "blank",
        class: "int-120"
      },
    ]);
    if(!(this.user && this.user.subscription_details)){
        await this.delayTime(1000);
      }
    this.checkSessionData();
    localStorage.removeItem("prevPath");
    localStorage.setItem("prevPath", this.$route.name);
    if (this.user.role_id == this.roleIds.PA) {
        this.initStudentData();
    } else {
        this.studentId = this.user.id;
    }
        this.downloadStatus = constants.DOWNLOAD_STATUS;

    this.reqGetList();
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },
  watch: {
    selectedExamTypes(val) {
      if (val) {
        this.reqGetList();
      }
    },
  },
  data() {
    return {
      headers: [],
      items: [],
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      orderBy: {
        field: "date_answered",
        order: "DESC"
      },
      selectedExamTypes: [],
      status: false,
      alertBoxData: {},
      modalwidth: "500px",
      testName: null,
      typetimeout:null,
      searchText: null,
      cComponent:
        "components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp",
      downloadStatus:{},
      requestIds:[],
      testStatusTimeout: 0,
      toasts:{}
    };
  },
  methods: {
    ...mapActions({
      getTestTarget: "utilStore/getTestTarget",
      improvementAssignmentList: "testStore/improvementAssignmentList",
      improvementAssignmentQueLoad: "testStore/improvementAssignmentQueLoad",
      getTestForImprovementAssignment:
        "testStore/getTestForImprovementAssignment",
      updateTestForImprovementAssignment:
        "testStore/updateTestForPracticeSession",
        getTestReportsList:
        "testStore/getTestReportsList",

      downloadTestPaper: "testStore/downloadTest",
      deleteDownloadData: "testStore/deleteDownloadData",
      getDownloadStatus: "testStore/getDownloadStatus",
    }),
    initStudentData() {
      this.isParent = true;   
      this.students = this.user.students.map((student) => {
        let studentObj = {
          text: student.name,
          value: {
            id: student.id,
            batchId: student.batch_id,
            type: student.type,
          },
        };
        return studentObj;
      });
      this.selectedStudent = this.students[0].value;
      this.studentId = this.selectedStudent.id;
      this.batchId = this.selectedStudent.batchId;
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.requestIds = crd.tabDetails[crd.selectedTab].requestIds|| []; // load center ids from session
        // this.selectedBatch = crd.tabDetails[crd.selectedTab].batchIds; // load batches in session
      }
      this.checkDownloadUpdate()
      this.reqGetTestTargets();
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {
          default: { page: 1, requestIds: [] },
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: "default",
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
    },
    reqGetTestTargets() {
      this.$root.showLoader = true;
      this.getTestTarget({})
        .then((response) => {
          this.loading = false;
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$toasted.error("Error getting exam types");
          this.loading = false;
          this.$root.showLoader = false;
        });
    },
    reqGetList() {
          this.$root.showLoader = true;
          let reqData = {
            test_types: this.selectedExamTypes,
            student_id: this.studentId,
            orderBy: this.orderBy,
            pagination: { page: this.currentPage, pageSize: this.pageSize }

          }
          if(this.testName){
            reqData.search_query = this.testName;
          }
          this.getTestReportsList(reqData)
            .then((response) => {
              this.loading = false;
              this.$root.showLoader = false;
              this.items = response.list;
              this.totalPages = response.pagination.pageCount;
            })
            .catch((err) => {
              this.$toasted.error("Error getting exam types");
              this.loading = false;
              this.$root.showLoader = false;
            });
    },
    startDate(startDate) {
      return startDate ? moment(startDate).format("DD/MM/YYYY") : "";
    },
    filterdOptions(opt) {
      const optName = constants.TEST_TYPES_TR.find(
        (x) => x.id === opt.test_type
      );
      return optName.title;
    },
    onPageChange(e) {
      this.currentPage = e;
      this.reqGetList();
    },
    onSortChange(e) {
      this.reqGetList();
    },
    onHeaderAction(e) {
      if (
        e.header &&
        e.header.type === "multidropdown" &&
        e.header.value === "test_type"
      ) {
        this.selectedExamTypes = e.data.selectedItems;
      }
    },
    onClose(data) {
      this.status = data.status;
      if (data && data.redirectTo) {
        this.redirectTo(data.redirectTo);
      }
    },
    onSearch() {
            this.resetFields();
            if (this.typetimeout) {
                clearTimeout(this.typetimeout);
            }
            this.typetimeout = setTimeout(() => {
                this.reqGetList();
            }, 1500);
        },
    resetFields() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.totalPages = 1;
    },
    downloadTest(item) {  
      const isRlated_student_for_parent = localStorage.getItem('Related_student_for_parent');
      const existingId = JSON.parse(isRlated_student_for_parent);
      if(existingId){
        item.related_student_for_parent_id = existingId;
      };
			let domainUrl = process.env.VUE_APP_API_URL;
			let token = sessionStorage.getItem('auth_token');
			let url =
				domainUrl +
				`/test/download-test-report/${item.id}?token=${token}`;
			//   alert(url);
			  // if (data.download_option === 2) {
          
        //   window.open(url, "_blank");
        // }else {
          this.downloadTestResource(existingId ? `/test/download-test-report/${item.id}?token=${token}&related_student_for_parent_id=${existingId}`: `/test/download-test-report/${item.id}?token=${token}`,item)
        // }
        //   alert(url);
      // }
    },
    downloadTestResource(url,test){
      this.items = this.items.map((item)=>{
        if (item.id === test.id) {
          item.status = constants.DOWNLOAD_STATUS.IN_PROGRESS
        }
        return item
      })
            this.toasts[test.id] =  this.$toasted.success("PDF creation under progress. Please do not leave this page",{icon: 'info',duration: null,id: test.id.toString()})

      this.downloadTestPaper(url)
      .then(res=>{
        // console.log(res);
        this.requestIds.push(res.request_id)
        this.updateRouteDetails({ type: "requestIds", data: { requestIds : this.requestIds} });

        this.items = this.items.map((item)=>{
          if (item.id === test.id) {
            item.request_id = res.request_id
          }
          return item
        })
        this.checkDownloadUpdate()
        // this.$toasted.success("PDF creation under progress. Please do not leave this page",{icon: 'info'})

        // this.requestGetTestList()
      })
      .catch(err=>{
        console.log(err);
        
      })
    },
    checkDownloadUpdate(){
      console.log(this.requestIds,'request_ids');
      if (this.testStatusTimeout) {
			  clearInterval(this.testStatusTimeout);
		  	this.testStatusTimeout = null;
		  }
      if (this.requestIds && this.requestIds.length) {
        this.testStatusTimeout = setInterval(()=>{
          this.getTestDownloadStatus()
        },10*1000)
      }
    },
    getTestDownloadStatus(){
      const reqData = {
        request_ids: this.requestIds,
        download_types: [constants.DOWNLOAD_TYPES.TEST_REPORT]
      }
      this.getDownloadStatus(reqData)
        .then(async(res) => {
          const arr = [];
          this.items.map((item) => {
            const data = res.find((r) => r.request_id == item.request_id);
            if (data && data.status === constants.DOWNLOAD_STATUS.COMPLETED) {
              item.url = data.url;
              item.status = data.status;
              if(item.url){
                arr.push({
                  url: data.url,
                  request_id: data.request_id
                })
              }
              // this.downloadTestURL(item)
              this.requestIds = this.requestIds.filter(
                (rid) => rid !== data.request_id
              );
              this.toasts[item.id].goAway(0)
              delete this.toasts[item.id]

              this.$toasted.success(`Your ${data.download_type} of ${item.test_name} PDF is successfully downloaded`,{icon: 'info'})
            }
          });
          for (let i = 0; i < arr.length; i++) {
            const item = arr[i];
            await this.downloadTestURL(item);
            
           await new Promise(resolve => {
            setTimeout(() => {
              resolve();
              }, 1000);
            });
          }
          if (!this.requestIds || !this.requestIds.length) {
            clearInterval(this.testStatusTimeout);
            this.testStatusTimeout = null;
          }
        })
        .catch((err) => {
       });
    },
    downloadTestURL(item){
      console.log(item);
      
      if (item.url && item.request_id) {
        
        window.open(item.url, "_self");
        const reqData= {
          request_id: item.request_id
        }
        item.status = null;
        item.request_id = null;
        item.url = null
        setTimeout(()=>{

          this.deleteDownloadData(reqData)
          .then(res=>{
          })
          .catch(err=>{
    
          })
        },5000)
      }

    },

    updateRouteDetails(details) {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      switch (details.type) {
        case "requestIds":
          crd.tabDetails[crd.selectedTab].requestIds = details.data.requestIds;
          break;
        default:
          break;
      }
      this.setRouteDetails(crd);
    },
  },
  beforeDestroy() {
    clearInterval(this.testStatusTimeout);
    this.testStatusTimeout = null;
  }
};
</script>
<style>
.download-icon{
  text-align: center;
}
.download-btn-cp3{
  margin: 0 auto;
}</style>